import { render, staticRenderFns } from "./DistributorModal.vue?vue&type=template&id=fb76a666&scoped=true"
import script from "./DistributorModal.vue?vue&type=script&lang=ts"
export * from "./DistributorModal.vue?vue&type=script&lang=ts"
import style0 from "./DistributorModal.vue?vue&type=style&index=0&id=fb76a666&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb76a666",
  null
  
)

export default component.exports